import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import Constants from "../../Action/Constants";

class PersonUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.id, 10);
    const person = this.component.props.app.persons.filter((person: PersonInterface) => person.id === id)[0];
    if (!!person) {
      return this.component.initializePage(person);
    } else {
      this.component.props.dispatch({
        type: Constants.GLOBAL_PERSON_FOR_PERSON_DETAILS_PAGE,
        payload: {
          contactId: id,
        },
        onSuccess: (person: PersonInterface) => {
          return this.component.initializePage(person);
        },
        onError: this.component.redirectBack
      });
    }
  }
}

export default new PersonUpdateWillMount();
